import yaml from 'js-yaml';

export type GraphFeature = 'notifications' | 'approvals';

export interface GraphAccessStatus {
  accessGranted?: boolean;
  grantedAt?: string;
  grantedBy?: string;
  pendingRequest?: boolean;
  requestedAt?: string;
  requestedBy?: string;
  adminEmail?: string;
}

export type GraphDomainsDoc = {
  version?: string;
  lastUpdated?: string;
  domains?: Record<string, Partial<Record<GraphFeature, GraphAccessStatus>>>;
};

export function parseGraphDomainsYaml(content: string): GraphDomainsDoc {
  const parsed = yaml.load(content);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error('Graph domains YAML must be a mapping at the root');
  }
  return parsed as GraphDomainsDoc;
}

export function graphDomainsDocToYaml(doc: GraphDomainsDoc): string {
  return yaml.dump(doc, { lineWidth: 120, noRefs: true, skipInvalid: true });
}

export {
  cloneDoc,
  ensureObject,
  asString,
  asBool,
  objectRecord,
  objectMap,
} from './tenant-config-form-utils';
